import React from "react";
import "./Blogs.css";
const BlogsCard = ({ blogdata }) => {
	return (
		<div className="col-md-4 my-2 blogs-card p-3">
			<div className="text-white">
				<a
					href={`${blogdata.link}`}
					className="text-decoration-none text-dark"
					target="__blank"
				>
					<div className="card mx-3 text-center text-decoration-none">
						<img
							src={blogdata.img}
							className="card-img-top"
							style={{ height: "200px" }}
							alt="..."
						/>
						<div className="card-body">
							<h5 className="card-title  ">{blogdata.name}</h5>
							<p className="card-text">{blogdata.description}</p>
						</div>
					</div>
				</a>
			</div>
		</div>
	);
};

export default BlogsCard;
